module.exports = __webpack_public_path__ + "media/images/admin/icons/bell-8a37b0ba7153701336069f154dc0134a.svg";